import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";
import { formatNumber, truncateText } from "../../../../../../utility/helper";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import { Pagination } from "../../../../../../components/Stepper/fields/inputField";
import { useSelector } from "react-redux";

const MovementComponent = ({
  viewTransaction,
  viewFutureTransaction,
  handleOptionSelect,
  confirmDelete,
  setLimit,
  limit,
  setPage,
  page,
  selectedAsset,
}) => {
  const [loading, setLoading] = useState(false);
  const { currency } = useSelector((state) => state.user);

  const onPageChange = (e) => {
    setPage(e.page);
    setLimit(e.rows);
  };

  const reasonTemplate = (rowData) => {
    return rowData.remark ? truncateText(rowData.reason, 19) : "-";
  };

  const currencyTemplate = (rowData) => {
    return currency ? currency : "-";
  };

  const valueTemplate = (rowData) => {
    return rowData.value ? (
      <div className="">{formatNumber(rowData.value)}</div>
    ) : (
      "-"
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <button
          disabled={rowData?.is_initial}
          className={`focus:outline-none mr-2 ${
            rowData?.is_initial
              ? "dark:text-gray-400 text-info cursor-not-allowed"
              : "text-primary"
          }`}
        >
          <FaEdit
            onClick={() => {
              if (!rowData?.is_default) {
                handleOptionSelect(rowData.type, "Update", rowData);
              }
            }}
          />
        </button>
        <button
          disabled={rowData?.is_initial}
          className={`focus:outline-none ${
            rowData?.is_initial
              ? "dark:text-gray-400 text-info cursor-not-allowed"
              : "text-darkWaring"
          }`}
        >
          <FaRegTrashAlt
            onClick={() => {
              if (!rowData?.is_default) {
                confirmDelete(rowData);
              }
            }}
          />
        </button>
      </div>
    );
  };

  const dateTemplate = (rowData) => {
    return moment(rowData.date).format("DD-MM-YYYY");
  };

  const cashTemplate = (rowData) => {
    const cashValue = rowData.value ? rowData.value : 0;
    const type = rowData.type?.toUpperCase();

    const formattedValue = cashValue === 0 ? "0" : formatNumber(cashValue);

    return type === "SELL" || type === "EXPENSE" ? (
      <>{cashValue !== 0 ? `-${formattedValue}` : formattedValue}</>
    ) : (
      <>{formattedValue}</>
    );
  };

  const P_AND_LTemplate = (rowData) => {
    const cashValue = rowData.p_and_l || 0;

    return <>{cashValue === 0 ? "-" : formatNumber(cashValue)}</>;
  };

  return (
    <div className="pb-4 border border-lightPrimary/40 dark:border-info/40 mt-6 dark:bg-custom-radial bg-white">
      <h2 className="text-2xl text-lightPrimary dark:text-primary-gradient font-semibold p-4">
        {viewTransaction?.asset_name
          ? `Real Estate - ${viewTransaction.asset_name}`
          : "No Asset found"}
      </h2>
      <DataTable
        value={viewTransaction?.transactions}
        className="transaction mt-3"
        sortMode="multiple"
        // paginator
        rows={limit}
        totalRecords={viewTransaction.total}
        first={page * limit}
        onPage={onPageChange}
        loading={loading}
        emptyMessage="No data available"
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column
          field="date"
          header="Date"
          body={dateTemplate}
          style={{ width: "10%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="type"
          header="Type"
          style={{ width: "13%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="remark"
          header="Reason"
          body={reasonTemplate}
          style={{ width: "10%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="value"
          header="Value"
          body={valueTemplate}
          align="right"
          style={{ width: "10%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="P&L"
          header="P&L"
          body={P_AND_LTemplate}
          align="right"
          style={{ width: "10%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        {/* <Column
          field="currency"
          header="Currency"
          align="right"
          body={currencyTemplate}
          style={{ width: "10%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        /> */}
        <Column
          field="asset_type_name"
          header="Asset"
          style={{ width: "13%" }}
          align="right"
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="amount"
          header="Cash"
          body={cashTemplate}
          align="right"
          style={{ width: "16%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="Action"
          header="Action"
          body={actionBodyTemplate}
          style={{ width: "15%" }}
          align="right"
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
      </DataTable>
      {viewTransaction?.total > limit && (
        <Pagination
          page={page}
          limit={limit}
          total={viewTransaction?.total || 0}
          onPageChange={(newPage) => setPage(newPage)}
        />
      )}
      <div className="mt-5 mb-3 pl-4 font-semibold text-lightPrimary text-black dark:text-primary-gradient">
        Future
      </div>
      <DataTable
        value={viewFutureTransaction?.transactions}
        className="transaction headerDisble"
        sortMode="multiple"
        // paginator
        rows={limit}
        totalRecords={viewFutureTransaction?.total}
        first={page * limit}
        // onPage={(e) => {
        //   setPage(e.page);
        //   setLimit(e.rows);
        // }}
        // loading={loading}
        emptyMessage=""
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column
          field="date"
          header="Date"
          body={dateTemplate}
          style={{ width: "10%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="type"
          header="Transaction Type"
          style={{ width: "13%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="remark"
          header="Reason"
          body={reasonTemplate}
          style={{ width: "10%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="value"
          header="Value"
          body={valueTemplate}
          style={{ width: "10%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="P&L"
          header="Unit Price"
          body={P_AND_LTemplate}
          style={{ width: "10%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="currency"
          header="Currency"
          style={{ width: "10%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="asset_type_name"
          header="Asset"
          style={{ width: "10%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="amount"
          header="Cash"
          body={cashTemplate}
          style={{ width: "13%" }}
        />
      </DataTable>
    </div>
  );
};

export default MovementComponent;
